import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BaseContainer } from 'secondstep-components'

export const Description = styled.span`
  line-height: 1.25rem;
  color: ${themeGet('colors.darkGray')};

  ${themeGet('breakpoints.mobile')} {
    margin-bottom: 0.5rem;
  }
`

export const StyledContainer = styled(BaseContainer).attrs(() => ({
  as: 'section',
}))`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 1rem 1.375rem 1.25rem;
  margin-top: 1.25rem;
  background-color: ${themeGet('colors.paleGray')};
  width: 100%;
  border-radius: 0.625rem;
  box-sizing: border-box;

  ${themeGet('breakpoints.mobile')} {
    padding: 1rem;
  }
`

export const StyledHr = styled.hr`
  width: 100%;
  height: 2px;
  border: none;
  margin: 0.625rem 0 1.125rem;
  background-color: ${themeGet('colors.white')};
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;
`

export const Title = styled.span`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  color: ${themeGet('colors.darkBlue')};
  margin-bottom: 0.25rem;
  font-size: 1rem;
`

export const TitleAndRecommendationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

export const Recommendation = styled.span`
  font-family: ${themeGet('font.molde.regular')};
  color: ${themeGet('colors.darkGray')};
  margin-bottom: 0.25rem;
  font-size: 0.813rem;
`
